var map = {
	"./10_nuts.png": 1899,
	"./1drink_12beer.png": 1900,
	"./1serving_8ounces.png": 1901,
	"./1serving_8ounces2.png": 1902,
	"./1serving_8ounces3.png": 1903,
	"./1serving_8ounces4.png": 1904,
	"./1serving_8ounces5.png": 1905,
	"./8ounces_1glass.png": 1906,
	"./can_1.png": 1907,
	"./can_2.png": 1908,
	"./can_3.png": 1909,
	"./cup.png": 1910,
	"./dried_serving_1/4cup.png": 1911,
	"./dried_serving_1:4cup.png": 1912,
	"./fresh_serving_1cup.png": 1913,
	"./glass_1.png": 1914,
	"./glass_2.png": 1915,
	"./golfball.png": 1916,
	"./halfthumb.png": 1917,
	"./hand_1.png": 1918,
	"./hand_2.png": 1919,
	"./hand_3.png": 1920,
	"./hand_4.png": 1921,
	"./hand_5.png": 1922,
	"./how.png": 724,
	"./serving_1/2cup.png": 1923,
	"./serving_1:2cup.png": 1924,
	"./serving_1tbsp.png": 1925,
	"./serving_3/4ounces.png": 1926,
	"./serving_3:4ounces.png": 1927,
	"./thumbx2.png": 1928,
	"./usda.png": 1929,
	"./vegetables_1cup.png": 1930,
	"./what.png": 722,
	"./wholethumb.png": 1931,
	"./why.png": 723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1898;